var React = require('react');

function Staff (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".5"},React.createElement("path",{"stroke":"#3E424E","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M2 70V58.948c0-6.165 5.038-11.194 11.216-11.194h5.48M53 70V58.948c0-6.16-5.038-11.194-11.216-11.194h-4.377M27.802 43.86c6.88 0 12.455-5.564 12.455-12.43 0-6.865-5.576-12.43-12.454-12.43-6.88 0-12.455 5.565-12.455 12.43 0 6.866 5.576 12.43 12.454 12.43zM42.917 25.297h3.869M71 41V33.2c0-4.348-3.556-7.902-7.917-7.902h-3.09M53.214 22.549c4.855 0 8.791-3.928 8.791-8.774C62.005 8.927 58.07 5 53.214 5c-4.856 0-8.792 3.928-8.792 8.774 0 4.847 3.936 8.775 8.792 8.775z"})));
}

Staff.defaultProps = {"width":"72","height":"72","fill":"none","viewBox":"0 0 72 72"};

module.exports = Staff;

Staff.default = Staff;
